import styled from 'styled-components'
import { Link } from 'react-router-dom'
import Icon from '../../../../components/Icon'

export const StyledLinkReport = styled(Link)`
    display: flex;
    justify-content: center;
`

export const StyledIcon = styled(Icon)`
    margin-left: 25px;
`